<div class="cc-tile-with-backBtn">
  <div (click)="gotoPermissionGrid()" class="title-backBtn">
    <span class="fas fa-long-arrow-alt-left"></span>
  </div>
  <h3>{{ pageTitle }}</h3>
</div>
<form [formGroup]="permissionGroupEdit" (ngSubmit)="save()">
  <div class="cc-content-wrapper">
    <div class="row">
      <div class="col-md-4 input">
        <label for="first-name"
          >{{ "_Permission_Edit_Permissions_Group_Name_Text_" | translate }}
          <span tabindex="-1" class="required-field">*</span>
        </label>
        <input
          app-filter
          pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$"
          id="permissionGroupName"
          (keyup)="onKeySearch($event)"
          class="form-control"
          formControlName="permissionGroupName"
          type="text"
          maxlength="50"
          [attr.disabled]="isViewOnly"
        />
        <div
          *ngIf="
            permissionGroupEdit
              .get('permissionGroupName')!
              .hasError('maxlength')
          "
          class="cc-validation"
        >
          <div>
            {{
              "_Permission_Edit_Invalid_Permissions_Group_Name_Text_"
                | translate
            }}
          </div>
        </div>
        <div
          *ngIf="
            permissionGroupEdit
              .get('permissionGroupName')!
              .hasError('required') &&
            permissionGroupEdit.get('permissionGroupName')!.touched
          "
          class="cc-validation"
        >
          <div>
            {{
              "_Permission_Edit_Required_Permissions_Group_Name_Text_"
                | translate
            }}
          </div>
        </div>
        <div
          *ngIf="
            permissionGroupEdit
              .get('permissionGroupName')!
              .hasError('permissionGroupNameExisting')
          "
          class="cc-validation"
        >
          <div>
            {{
              permissionGroupEdit.get("permissionGroupName")!.errors!
                .permissionGroupNameExisting
            }}
          </div>
        </div>
      </div>
      <div class="col-md-4 checkbox d-flex justify-content-center mt-4">
        <label>
          <input
            id="notificationgroup"
            formControlName="notificationGroup"
            class="cc-filter-checkbox set-pointer-events"
            type="checkbox"
            kendoCheckBox
            [attr.disabled]="
              isEditting || notificationGroupCheckBoxDisable ? true : null
            "
            [title]="hoverOverMessageOnNotificationGroupCheckbox"
            (change)="valueChange()"
          />
          {{ "_Permission_Edit_Notification_Group_Text_" | translate }}
        </label>
      </div>
      <div class="col-md-4 checkbox d-flex justify-content-center mt-4">
        <label>
          <input
            id="selectAllPermissions"
            formControlName="selectAllPermissions"
            class="cc-filter-checkbox set-pointer-events"
            type="checkbox"
            kendoCheckBox
            [attr.disabled]="
              permissionGroupEdit.get('notificationGroup')!.value == true ||
              isViewOnly ||
              disabledSelectAll
                ? true
                : null
            "
            (change)="valueChangeBySelectAll($event)"
          />
          {{ "_Permission_Edit_SelectAll_Permissions_Text_" | translate }}
        </label>
      </div>
    </div>
  </div>
  <!-- Accordions -->
  <ngb-accordion
    [closeOthers]="true"
    #acc="ngbAccordion"
    class="cc-accordion"
    [destroyOnHide]="false"
    [activeIds]="activeIds"
  >
    <ngb-panel
      id="ngb-panel-0"
      [disabled]="permissionGroupEdit.get('notificationGroup')?.value == true"
    >
      <ng-template ngbPanelTitle>
        <span class="accordion-title">{{
          "_Permission_Edit_Administrative_Permissions_Title_Text_" | translate
        }}</span>

        <span class="caret"></span>
      </ng-template>
      <ng-template ngbPanelContent class="cc-tab-content">
        <app-permissions-admin
          [allPermissionsInCategory]="allPermissionReferences"
          (AdminObject)="onAdminChildObjectUpdate($event)"
          (dirtyEmitter)="updateFormDirty($event)"
          [isViewOnly]="isViewOnly"
          [isUkgDefaultGroup]="isUkgDefaultGroup"
          (sectionSelectAll)="onSectionSelectAll($event)"
          #permissionAdmin
        >
        </app-permissions-admin>
      </ng-template>
    </ngb-panel>
    <!-- Lobby Permissions Tab -->
    <ngb-panel
      id="ngb-panel-2"
      *ngIf="isLTLicenseEnabled$ | async"
      [disabled]="permissionGroupEdit.get('notificationGroup')!.value == true"
    >
      <ng-template ngbPanelTitle>
        <span class="accordion-title">{{
          "_Permission_Edit_Lobby_Permissions_Title_Text_" | translate
        }}</span>

        <span class="caret"></span>
      </ng-template>
      <ng-template ngbPanelContent class="cc-tab-content">
        <app-permissions-lobby
          [allPermissionsInCategory]="allPermissionReferences"
          (LobbyObject)="onLobbyChildObjectUpdate($event)"
          (dirtyEmitter)="updateFormDirty($event)"
          [isViewOnly]="isViewOnly"
          [isUkgDefaultGroup]="isUkgDefaultGroup"
          (sectionSelectAll)="onSectionSelectAll($event)"
          #permissionLobby
        >
        </app-permissions-lobby>
      </ng-template>
    </ngb-panel>

    <!-- Reports Permissions Tab  -->
    <ngb-panel
      id="ngb-panel-3"
      *ngIf="isLTLicenseEnabled$ | async"
      [disabled]="permissionGroupEdit.get('notificationGroup')!.value == true"
    >
      <ng-template ngbPanelTitle>
        <span class="accordion-title">{{
          "_Permission_Edit_Analytics_Permissions_Title_Text_" | translate
        }}</span>

        <span class="caret"></span>
      </ng-template>
      <ng-template ngbPanelContent class="cc-tab-content">
        <app-permissions-reports
          [allPermissionsInCategory]="allPermissionReferences"
          (ReportObject)="onReportChildObjectUpdate($event)"
          (dirtyEmitter)="updateFormDirty($event)"
          [isViewOnly]="isViewOnly"
          [isUkgDefaultGroup]="isUkgDefaultGroup"
          (sectionSelectAll)="onSectionSelectAll($event)"
          #permissionReports
        >
        </app-permissions-reports>
      </ng-template>
    </ngb-panel>
    <!-- Appointment Concierge Permissions Tab  -->
    <ngb-panel
      id="ngb-panel-4"
      *ngIf="isACLicenseEnabled$ | async"
      [disabled]="permissionGroupEdit.get('notificationGroup')!.value == true"
    >
      <ng-template ngbPanelTitle>
        <span class="accordion-title">{{
          "_Permission_Edit_Appointments_Permissions_Title_Text_" | translate
        }}</span>

        <span class="caret"></span>
      </ng-template>
      <ng-template ngbPanelContent class="cc-tab-content">
        <app-permissions-appointment-concierge
          [allPermissionsInCategory]="allPermissionReferences"
          (AppointementsObject)="onAppointmentsObjectUpdate($event)"
          (dirtyEmitter)="updateFormDirty($event)"
          [isViewOnly]="isViewOnly"
          [isUkgDefaultGroup]="isUkgDefaultGroup"
          (sectionSelectAll)="onSectionSelectAll($event)"
          #permissionAppointments
        >
        </app-permissions-appointment-concierge>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
  <div class="cc-btn-panel">
    <button
      *ngIf="isViewOnly"
      type="button"
      class="btn btn-secondary"
      (click)="gotoPermissionGrid()"
    >
      {{ "_Permission_Edit_Back_Button_Text_" | translate }}
    </button>
    <!--Need to cross check with wireframe whether need to keep the close-->
    <button
      *ngIf="!isViewOnly"
      type="button"
      class="btn btn-secondary"
      (click)="gotoPermissionGrid()"
    >
      {{ "_General_Button_Cancel_Text_" | translate }}
    </button>
    <span title="{{ saveButtonTooltip | translate }}">
      <button
        *ngIf="!isViewOnly"
        type="submit"
        id="submitPermissionGroupbutton"
        [disabled]="
          !isDirty ||
          !permissionGroupEdit.valid ||
          !isSubsectionsValid ||
          (permissionGroupEdit.get('notificationGroup')!.value == false &&
            !anyPermissionSelected)
        "
        class="btn btn-primary"
      >
        {{ "_General_Button_Save_Text_" | translate }}
      </button>
    </span>
  </div>
</form>
